import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './main/main.component';
import { AuthGuardService } from './modules/shared/guards/auth.guard';

const routes: Routes = [
  { path: "", redirectTo: "/auth", pathMatch: "full" },
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'main',
    canActivate: [AuthGuardService],
    component: MainComponent,
    children: [
      {
        path: 'users',
        loadChildren: () => import('./modules/user/user.module').then((module) => module.UserModule),
      },
      {
        path: 'admins',
        loadChildren: () => import('./modules/admin/admin.module').then((module) => module.AdminModule),
      },
      {
        path: 'tasks',
        loadChildren: () => import('./modules/task/task.module').then((module) => module.TaskModule),
      },
      {
        path: 'categories',
        loadChildren: () => import('./modules/category/category.module').then((module) => module.CategoryModule),
      },
    ]
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
